<script setup lang="ts">
import { ModalsContainer } from 'vue-final-modal';
import useLayout from './layouts/useLayout';
import BottomSheetsContainer from '@components/base/mr-modal/BottomSheetsContainer.vue';
import MobileNav from '@components/layout/mobile/MobileNav.vue';
const { showDrawer } = useLayout();
</script>

<template>
    <NuxtLayout :show-drawer>
        <NuxtPage :show-drawer />
    </NuxtLayout>
    <Transition name="mobile-nav">
        <MobileNav v-if="!showDrawer" />
    </Transition>
    <ModalsContainer />
    <BottomSheetsContainer />
</template>

<style scoped lang="scss">
$duration: 200ms;

.mobile-nav-leave-active {
    animation: $duration leave-animation;
}

.mobile-nav-enter-active {
    animation: $duration enter-animation;
}

@keyframes enter-animation {
    from {
        transform: translateY(100%);
    }
    to {
        transform: translateY(0);
    }
}

@keyframes leave-animation {
    from {
        transform: translateY(0);
    }
    to {
        transform: translateY(100%);
    }
}
</style>
